import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartsMainViewComponent } from 'projects/cart-tv/src/app/carts-main-view/carts-main-view.component';
import { CartViewComponent } from 'projects/cart-tv/src/app/carts-main-view/cart-view/cart-view.component';
import {
  CartCabinetEditDialogComponent
} from 'projects/cart-tv/src/app/carts-main-view/cart-cabinet-edit-dialog/cart-cabinet-edit-dialog.component';
import {
  CartProjectEditDialogComponent
} from 'projects/cart-tv/src/app/carts-main-view/cart-project-edit-dialog/cart-project-edit-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { ListboxModule } from 'primeng/listbox';
import { MiscModule } from 'projects/core/src/lib/misc/misc.module';
import { MatDialogModule } from '@angular/material/dialog';
import { AppRoutingModule } from 'projects/cart-tv/src/app/app-routing.module';
import { CoreModule } from 'projects/core/src/lib/core/core.module';
import { BrowserModule } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
  declarations: [
    CartsMainViewComponent,
    CartViewComponent,
    CartCabinetEditDialogComponent,
    CartProjectEditDialogComponent
  ],
  imports: [
    CoreModule,
    MatIconModule,
    BrowserModule,
    CommonModule,
    MatButtonModule,
    ListboxModule,
    MiscModule,
    MatDialogModule,
    AppRoutingModule
  ],
  exports: [
    CartsMainViewComponent,
    CartViewComponent
  ]
})
export class CartsModule {
}
